import React from 'react';
import { useTranslation } from 'react-i18next';
import { FindStore as FindStoreTrans } from 'autogen/translation-keys/trans-website-shared';
import Icon from 'components/Icon';
import { SessionMenuAnchorItem } from 'components/SessionMenu/components/SessionMenuItem';
import type { LinkAction } from 'components/shared/Routing/components/LinkAction/shared/types';
import { HeaderItemText } from './shared/styles';

export default function FindStore({ linkAction, ...restProps }: { linkAction: LinkAction }) {
    const { t } = useTranslation();

    return (
        <SessionMenuAnchorItem
            icon={<Icon type="Pin" size={16} aria-hidden />}
            action={linkAction}
            aria-label={t(FindStoreTrans)}
            {...restProps}
        >
            <HeaderItemText>{t(FindStoreTrans)}</HeaderItemText>
        </SessionMenuAnchorItem>
    );
}
